import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'
import PageHeader from '../components/PageHeader'
import PartesTabla from '../components/partes/PartesTabla'
import PartePanel from '../components/partes/PartePanel'
import AbrirParteModal from '../components/partes/AbrirParteModal'
import CerrarParteModal from '../components/partes/CerrarParteModal'
import HistorialLista from '../components/unidades/HistorialLista'
import Disponibilidad from '../components/partes/Disponibilidad'
import { usePuedeAbrirPartes } from '../utils/mantenimiento'
import { ControlZoom, ZonaZoom } from '../components/ot/zoom'
import { useZoom } from '../components/ot/useZoom'

// Mantenimiento > Partes: maintenance reports on the Planilla's units.
export default function Partes() {
  const { t } = useTranslation('engineering')
  const puedeEditar = usePuedeAbrirPartes()               // the button that opens a parte (the rest of the page edits nothing here)
  const [vista, setVista] = useState('tabla')      // 'tabla' | 'disponibilidad' | 'historial'
  const zoom = useZoom('mant_zoom_partes')
  const [abriendo, setAbriendo] = useState(false)
  const [cerrando, setCerrando] = useState(null)   // the parte being closed from the board
  // The open panel lives in the address (?parte=<id>), so a unit's parte
  // history can link straight to one, and the link can be shared.
  const [searchParams, setSearchParams] = useSearchParams()
  const panelId = searchParams.get('parte') ? Number(searchParams.get('parte')) : null
  const setPanelId = (id) => setSearchParams(sp => {
    const next = new URLSearchParams(sp)
    if (id == null) next.delete('parte')
    else next.set('parte', String(id))
    return next
  })
  // Partes opened, edited or closed on this page since the board loaded.
  const [actualizados, setActualizados] = useState({})
  const actualizar = (p) => setActualizados(a => ({ ...a, [p.id]: p }))

  return (
    <div className="p-8">
      <div className="mb-6">
        <PageHeader
          title={t('partes.title')}
          subtitle={t('partes.subtitle')}
          actions={puedeEditar && (
            <button onClick={() => setAbriendo(true)}
              className="bg-gray-900 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-gray-800 transition-colors">
              {t('partes.abrir.button')}
            </button>
          )}
        />
      </div>

      <div className="flex flex-wrap items-center gap-3 mb-5">
        <div className="inline-flex rounded-lg border border-gray-200 bg-white p-0.5">
          {['tabla', 'disponibilidad', 'historial'].map(v => (
            <button key={v} type="button" onClick={() => setVista(v)}
              className={`px-3.5 py-1.5 rounded-md text-sm font-medium transition-colors ${
                vista === v ? 'bg-gray-900 text-white' : 'text-gray-500 hover:text-gray-900'}`}>
              {t(`unidades.vistas.${v}`)}
            </button>
          ))}
        </div>
        <ControlZoom z={zoom} />
      </div>

      <ZonaZoom z={zoom} libre>
        {vista === 'historial' && <HistorialLista ambito="partes" onOpenParte={setPanelId} />}
        {vista === 'disponibilidad' && <Disponibilidad key={Object.keys(actualizados).length} onOpenParte={setPanelId} />}
        {vista === 'tabla' && <PartesTabla actualizados={actualizados} onOpenParte={setPanelId} onCerrar={setCerrando} />}
      </ZonaZoom>

      {abriendo && (
        <AbrirParteModal onClose={() => setAbriendo(false)}
          onCreated={p => { actualizar(p); setPanelId(p.id) }}
          onVerParte={setPanelId} />
      )}
      {cerrando && (
        <CerrarParteModal parte={cerrando} onClose={() => setCerrando(null)} onClosed={actualizar} />
      )}
      {panelId != null && (
        <PartePanel key={panelId} parteId={panelId} onClose={() => setPanelId(null)} onChanged={actualizar} />
      )}
    </div>
  )
}
